import { ValidSheba } from "@payping/utils/validation";

export const createIbanValidator = (t: (key: string) => string) => (_: any, value: string) => {
  if (value && !ValidSheba(`IR${value}`)) {
    return Promise.reject(new Error(t("shabaValidation")));
  }
  return Promise.resolve();
};

export const createDuplicateIbanValidator =
  (form: any, fieldName: string, t: (key: string) => string) => (_: any, value: string) => {
    if (!value || value.trim() === "") {
      return Promise.resolve();
    }

    // Only check fields that come before this field
    const fieldOrder = ["iban1", "iban2", "iban3"];
    const currentIndex = fieldOrder.indexOf(fieldName);
    const previousFields = fieldOrder.slice(0, currentIndex);

    const previousValues = previousFields
      .map((field) => form.getFieldValue(field))
      .filter((val) => val && val.trim() !== "");

    if (previousValues.includes(value)) {
      return Promise.reject(new Error(t("profile.bank.duplicateIbanError")));
    }

    return Promise.resolve();
  };

export const checkForDuplicateIbans = (values: any): boolean => {
  const ibans = [values.iban1, values.iban2, values.iban3].filter((iban) => iban && iban.trim() !== "");
  const uniqueIbans = new Set(ibans);
  return ibans.length !== uniqueIbans.size;
};
